import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

interface StructuredDataProps {
  type: 'Organization' | 'WebSite' | 'Article' | 'BreadcrumbList';
  data: any;
}

const StructuredData: React.FC<StructuredDataProps> = ({ type, data }) => {
  useEffect(() => {
    const script = document.createElement('script');
    script.type = 'application/ld+json';
    script.id = `structured-data-${type.toLowerCase()}`;
    
    // 移除旧的数据（如果存在）
    const oldScript = document.getElementById(script.id);
    if (oldScript) {
      oldScript.remove();
    }

    script.text = JSON.stringify(data);
    document.head.appendChild(script);

    return () => {
      const scriptToRemove = document.getElementById(script.id);
      if (scriptToRemove) {
        scriptToRemove.remove();
      }
    };
  }, [type, data]);

  return null;
};

// 生成网站的结构化数据
export const getWebsiteStructuredData = () => ({
  '@context': 'https://schema.org',
  '@type': 'WebSite',
  name: 'Titron',
  alternateName: 'Titron (TRN)',
  url: 'https://titron.org',
  description: 'Titron is a privacy protection and data sovereignty foundational protocol built for Web3. Through zero-knowledge proofs and homomorphic encryption technology, it enables individuals and organizations to securely share and utilize data value with verifiable guarantees.',
  potentialAction: {
    '@type': 'SearchAction',
    target: {
      '@type': 'EntryPoint',
      urlTemplate: 'https://titron.org/search?q={search_term_string}'
    },
    'query-input': 'required name=search_term_string'
  }
});

// 生成组织的结构化数据
export const getOrganizationStructuredData = () => ({
  '@context': 'https://schema.org',
  '@type': 'Organization',
  name: 'Titron',
  alternateName: 'Titron Protocol',
  url: 'https://titron.org',
  logo: 'https://titron.org/images/Logo.jpg',
  description: 'Titron is a blockchain-based privacy protection protocol dedicated to providing data sovereignty and privacy protection infrastructure for the Web3 ecosystem.',
  sameAs: [
    'https://github.com/annaufdga',
    'https://x.com/Titron_TRN'
  ],
  contactPoint: {
    '@type': 'ContactPoint',
    contactType: 'Support',
    availableLanguage: ['en', 'zh']
  }
});

// 生成面包屑导航的结构化数据
export const getBreadcrumbStructuredData = (items: Array<{ name: string; url: string }>) => ({
  '@context': 'https://schema.org',
  '@type': 'BreadcrumbList',
  itemListElement: items.map((item, index) => ({
    '@type': 'ListItem',
    position: index + 1,
    name: item.name,
    item: item.url
  }))
});

export default StructuredData;

